var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.entries.length
    ? _c(
        "div",
        {
          staticClass: "mb-3"
        },
        _vm._l(_vm.entries, function(e) {
          return _c("kvm-docker-operation", {
            key: e.serviceId + ":" + e.op.id,
            attrs: {
              "service-id": e.serviceId,
              operation: e.op
            },
            on: {
              done: function done($event) {
                return _vm.$emit(
                  "done",
                  Object.assign(
                    {
                      serviceId: e.serviceId
                    },
                    $event
                  )
                )
              },
              dismiss: function dismiss($event) {
                return _vm.dismiss(e)
              }
            }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }